export default "__VITE_ASSET__CPDQvw1j__"